import { NetworkService } from '../services'
import { RequestUserConfig } from '../common/types'
import { BaseTransport } from '../transports'

class DataEventClient {
    public sendSearchResultListingEvent({
        user,
        filter,
    }: {
        user: RequestUserConfig
        filter: string
    }): Promise<BaseTransport<void>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.post({
            url: '/api/v1/data-events/search-result-listing',
            headers,
            params: { filter },
        })
    }
}

export default new DataEventClient()
